import styled from "styled-components";

export const HomePageMainWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    background-color: ${props.theme.colors.white.bgWhite};
    position: relative;
    padding-bottom: ${props.theme.spacing.large.l30};
  `
);

export const HomePageTopWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    height: 40rem;
    background-image: radial-gradient(circle at 50% 100%, #325f93, #0a223d 40%);
    position: relative;
  `
);

export const HomePageInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
  `
);

export const HomePageTopInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    max-width:120rem;
    margin:0 auto;

  `
);

export const HomeContentWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    max-width:120rem;
    margin:0 auto;
    padding-top: ${props.theme.spacing.large.l30};
  `
);

export const SearchWidgetWrapp = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    margin-top: ${props.theme.spacing.large.l40};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    box-shadow: 0 1px 100px 0 ${props.theme.colors.black.light1};
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l30};
    position: relative;
  `
);

export const SearchWidgetHeadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `
);

export const SearchWidgetHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font20};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const SearchBtnWrap = styled.div(
  props => `
    width:22rem;
    height: 5rem;
    display: flex;
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
  `
);

export const SearchBtn = styled.button(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height:5rem;
    background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
    border-radius: 3.8rem;
    border:none;
    font-size: ${props.theme.font.large.font24};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.black};
    outline:none;
    cursor: pointer;
  `
);

export const GoSafeCardBlockWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top:${props.theme.spacing.large.l12};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    box-shadow: 0 3px 30px 0  ${props.theme.colors.black.light1};
  `,
);

export const GoSafeCardBannerWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top:${props.theme.spacing.large.l12};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
  `,
);

export const PopOverlay = styled.div(
  props => `
    width:100%;
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.9);
    align-items: center;
    justify-content: center;
    height: 100vh;
    z-index: 9;
  `
);

export const PopModal = styled.div(
  props => `
    width: 60%;
    height: 50rem;
    max-height: 50rem;
    overflow:auto;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: ${props.theme.misc.zIndex.xxlarge};
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
  `
);

export const PopHeadwrap = styled.div(
  props => `
    width: 100%;
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: sticky;
    top:0;
    z-index: 1;
  `
);

export const PopupCloseBtn = styled.a(
  props =>`
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props.theme.colors.white.base};
  width:4rem;
  height: 4rem;
  text-decoration: none;
  border-radius: 50%;
  color: ${props.theme.colors.black.base};
`);


export const PopupBodyWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l20};
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `
);

export const PromoImgWrap = styled.div(
  props => `
    width:58rem;
    height: 32rem;
    img{
      width:58rem;
      height: 32rem;
      cursor: pointer;
    }
  `
);

export const PopInnerWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    padding: ${props.theme.spacing.large.l20};
  `
);

export const PopHeadingWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `
);

export const MainHeadText = styled.h3(
  props => `
    font-size: ${props.theme.font.large.font22};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.black.base};
  `
);

export const MainSubText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};
    font-weight: ${props.theme.font.fontWeight.medium};
    color: ${props.theme.colors.black.base};
  `
);

export const SubText = styled.span(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
  `
);


export const PopContentWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding-top: ${props.theme.spacing.large.l20};
    margin: ${props.theme.spacing.large.l20} 0;
  `
);

export const FirstRowWrap = styled.div(
  props => `
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 ${props.theme.spacing.small.s5};
  `
);

export const RowContentWrap = styled.div(
  props => `
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${props.theme.spacing.small.s5};
    background-color: ${props.theme.colors.blue.base};
    border-radius: 0.4rem;
    margin-bottom: ${props.theme.spacing.base};
  `
);

export const AgentName = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};
    text-transform: uppercase;
  `
);

export const AgentPlace = styled.span(
  props => `
    font-size: ${props.theme.font.large.font13};
    color: ${props.theme.colors.white.base};
  `
);

export const SecondRowWrap = styled.div(
  props => `
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 ${props.theme.spacing.small.s5};
  `
)

export const MenuIconOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    margin-top: -${props.theme.spacing.large.l50};
    margin-bottom: ${props.theme.spacing.base};
    aling-items: center;
    justify-content: center;
  `
);

export const MenuIconInnerWrap = styled.div(
  props => `
    display: flex;
    padding: 0 ${props.theme.spacing.base};
    background-color: ${props.theme.colors.white.base};
    border-radius: 0.8rem;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  `
);

export const MenuWrapList = styled.div(
  props => `
    list-style-type: none;
    display: flex;

    li{
      padding: 0 ${props.theme.spacing.base} ${props.theme.spacing.small.s2};
      display: flex;
      flex-direction: column;
      border-bottom: 3px solid transparent;
      margin: 0 ${props.theme.spacing.base};
      cursor: pointer;

      p{
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        padding-bottom: ${props.theme.spacing.small.s5};
        font-weight: ${props.theme.font.fontWeight.bold};
      }

      &.active{
        border-bottom: 3px solid ${props.theme.colors.blue.base};

        p{
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.blue.base};
          padding-bottom: ${props.theme.spacing.small.s5};
          font-weight: ${props.theme.font.fontWeight.bold};
        }
      }

      &:hover{
        p{
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.blue.base};
          padding-bottom: ${props.theme.spacing.small.s5};
          font-weight: ${props.theme.font.fontWeight.bold};
        }
      }
    }
  `
);

export const NewTag = styled.span(
  props => `
    position: absolute;
    top: -40px;
    background-image: linear-gradient(67deg, #43e1a8, #219393);
    border-radius: 7px;
    padding: 2px 5px;
    font-size: ${props.theme.font.small.font10};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};
  `
)